module.exports = __webpack_public_path__ + "img/agency-service-01.ae90e8f4.jpg";